module.exports = __webpack_public_path__ + "static/media/fleur-gray.faf24e3c.svg";